import enrollCmd from "../base/enrollCmd";

export const enrollCameraMsg = () => {
    return "{'enrollType':'" + enrollCmd.CMD_CAMERA + "'}";
};